"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var classicConfig = {
  backgroundColor: {
    default: '#335c6d',
    error: '#C7384F',
    help: '#FFAB00',
    info: '#1573E6',
    maintenance: '#FF7D00',
    new: '#663399',
    success: '#50B848',
    warning: '#FF7D00',
    none: 'transparent'
  }
};
var _default = classicConfig;
exports.default = _default;